/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import PETVideo from "../../../../assets/final-images/servicepage/pet-page/Artboard 1.jpg";
import OncologyImage from "../../../../assets/final-images/servicepage/pet-page/Artboard 2.jpg";
import NeuroendrocrinePET from "../../../../assets/final-images/servicepage/pet-page/Artboard 3.jpg";
import ComparisonBrain from "../../../../assets/final-images/servicepage/pet-page/Artboard 4.jpg";
import ScanImage from "../../../../assets/final-images/servicepage/pet-page/1.png";
import NaturalImage from "../../../../assets/final-images/servicepage/pet-page/young-family-with-two-sons-together-outside-park (1).jpg";
import DoneIcon from "@mui/icons-material/Done";
import { Link } from "react-router-dom";
import { useLenis } from "../../../SmoothScroll";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import shape from "../../../../assets/final-images/shapes/8-01-01.png";
import Faqs from "../../../Faqs";
import { Helmet } from "react-helmet-async";
export default function PET() {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  const faqs = [
    {
      question:
        "What is a PET/CT scan and how is it different from a regular CT or MRI?",
      answer:
        "A PET/CT (Positron Emission Tomography / Computed Tomography) scan is a hybrid imaging study that combines two complementary technologies in a single session. The PET component uses a small amount of radioactive tracer to measure metabolic and biological activity at the cellular level - detecting disease by how cells function, not just how they look. The CT component provides precise anatomical context, mapping exactly where in the body that abnormal activity is occurring. This combination is uniquely powerful: a CT or MRI shows anatomy and structure, while PET reveals physiology and function. PET/CT can detect cancer, infection, neurological disease, and other conditions earlier and with greater precision than anatomy-based imaging alone. Citrus Diagnostic Center offers a comprehensive suite of PET/CT studies in Crystal River, FL, interpreted by our board-certified radiologist.",
    },
    {
      question:
        "What types of PET/CT studies does Citrus Diagnostic Center offer?",
      answer:
        "Citrus Diagnostic Center offers a full spectrum of clinically advanced PET/CT studies, including: FDG PET/CT (fluorodeoxyglucose) for oncology cancer staging, restaging, and treatment response assessment; PSMA PET/CT (Prostate-Specific Membrane Antigen) for prostate cancer staging and biochemical recurrence detection; Brain Amyloid PET/CT for Alzheimer's disease evaluation and anti-amyloid therapy eligibility; Netspot (Gallium-68 DOTATATE) PET/CT for neuroendocrine tumor detection, staging, and Lutathera eligibility assessment - Citrus Diagnostic Center specifically uses Netspot, the FDA-approved Ga-68 DOTATATE radiopharmaceutical; and Brain Tau PET/CT for tauopathy evaluation in select neurodegenerative conditions. This breadth of PET/CT capabilities is rare in an independent outpatient setting and reflects our commitment to bringing advanced molecular imaging to the Crystal River and Citrus County community.",
    },
    {
      question:
        "How do I prepare for a PET/CT scan at Citrus Diagnostic Center?",
      answer:
        "Preparation varies depending on the specific PET/CT tracer ordered. For FDG oncology PET/CT: fast for four to six hours (water permitted), avoid strenuous exercise for 24 hours, and hold metformin as directed by your physician. For PSMA PET/CT: minimal preparation is required, though hydration is encouraged. For brain amyloid PET: no fasting required. For Netspot (Ga-68 DOTATATE) neuroendocrine PET: no fasting required, but long-acting somatostatin analog medications (Sandostatin LAR, Somatuline) must be held for four to six weeks before the scan - this is critical and must be planned in advance. Our scheduling team will provide complete, individualized preparation instructions based on the specific study ordered by your physician.",
    },
    {
      question:
        "Is a PET/CT scan safe? How much radiation exposure is involved?",
      answer:
        "PET/CT is considered safe and is routinely performed on patients of all ages when clinically indicated. The radiation exposure comes from two sources: the radioactive tracer (which has a short half-life and clears the body within hours) and the CT component (which uses low-dose protocols at Citrus Diagnostic Center). The combined effective dose from a standard FDG PET/CT is approximately 14 to 25 millisieverts (mSv) - comparable to natural background radiation over several years, and justified by the significant diagnostic benefit in serious conditions such as cancer and neurological disease. Pregnant patients should discuss alternative imaging with their physician.",
    },
    {
      question:
        "How long does a PET/CT scan take and when will results be available?",
      answer:
        "Total appointment time for most PET/CT studies at Citrus Diagnostic Center is two to three hours, including the radiotracer injection, an uptake waiting period (typically 45 to 90 minutes depending on the tracer), and the scan itself (20 to 45 minutes). You will be asked to rest quietly during the uptake period to minimize background muscle activity. After the scan, images are analyzed and interpreted by our board-certified radiologist. Reports are typically delivered to your referring physician within 24 to 48 hours for routine studies, with STAT reads available for urgent clinical situations.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>PET-CT Imaging for Cancer Evaluation | Citrus County</title>
        <meta
          name="description"
          content="What is PET-CT used for? Advanced imaging for cancer detection, staging, and treatment monitoring-supported by precise protocols and clinical expertise.
"
        />
        <meta
          name="keywords"
          content="pet scan for cancer
pet scan imaging
psma Pet scanning
Pet scan for Prostate Cancer
brain pet imaging
prep for pet scan for cancer


"
        />
      </Helmet>
      <div className=" font-robout">
        {/* Hero Section */}
        <div className="relative px-4 sm:px-8">
          <div className="flex flex-col justify-center items-center px-5 xl:px-0 xl:pb-24 xl:pt-36 text-center">
            <h1
              data-aos="fade-right"
              className="font-heading lg:text-[72px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal  capitalize"
            >
              PET-CT Imaging at Citrus Diagnostic Center
            </h1>
            <p
              data-aos="fade-right"
              data-aos-delay="100"
              className=" text-[#cccccc] font-normal "
            >
              Molecular insight, guided by experience.
            </p>
          </div>
        </div>
      </div>
      <div>
        <div className=" md:max-w-[90%] w-11/12  xl:px-5 mx-auto   xl:my-28 ">
          <div className="relative xl:my-20 xl:bg-[#0f0f0f] rounded-xl xl:py-24">
            <img
              src={shape}
              alt="Citrus Diagnostic Center"
              className="
              absolute 
              top-1/2 
              left-1/2 
              -translate-x-1/2 
              -translate-y-1/2 
              pointer-events-none 
              z-0
              opacity-55
            "
            />
            <div
              className="xl:pb-10 text-center flex flex-col items-center backdrop-blur-[2px]
    xl:bg-[#ffffff13] rounded-xl
      shadow-lg xl:py-24 py-10 w-full xl:w-[80%] mx-auto"
            >
              <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading capitalize pb-2 xl:pb-8 xl:text-center text-left ">
                A Legacy in PET & Molecular Imaging
              </h2>

              <p className="py-2 text-[#cccccc] font-normal xl:text-center text-left ">
                PET imaging is not simply a test-it is a{" "}
                <span className="font-extrabold">medical subspecialty.</span>
              </p>

              <p className="pb-2 max-w-[900px] xl:text-center text-left ">
                Citrus Diagnostic Center was built on a foundation of{" "}
                <span className="font-extrabold">
                  PET and nuclear medicine excellence.
                </span>{" "}
                Long before PET-CT became widely available, this practice
                invested in molecular imaging as a core capability, guided by
                academic training and clinical rigor.
              </p>

              {/* centered list section */}
              <div className="text-left">
                <p className="py-2 text-[#cccccc]">
                  That legacy continues today through:
                </p>

                <ul className="mx-auto max-w-[520px] text-left space-y-2 text-[#cccccc] font-robout leading-[1.4em] font-medium">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Decades of focused PET and nuclear medicine experience
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Academic training lineage from leading institutions
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Continuous evolution of PET protocols as standards of care
                      advance
                    </span>
                  </li>
                </ul>

                <p className="py-2">
                  PET is not an add-on here. It is part of our DNA.
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20  lg:py-20 pb-10 xl:p-24 xl:bg-[#0f0f0f]">
            <div className="rounded-xl  md:p-10  xl:p-8  xl:bg-[#000] ">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize xl:pb-8 pb-4 ">
                What Is PET-CT?
              </h2>
              <p className="pb-2">PET-CT combines:</p>
              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>
                    <span className="font-extrabold">
                      Positron Emission Tomography (PET)
                    </span>{" "}
                    - functional, metabolic information
                  </span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>
                    <span className="font-extrabold">
                      Computed Tomography (CT)
                    </span>{" "}
                    - detailed anatomic localization
                  </span>
                </li>
              </ul>
              <p className=" py-2">
                Together, they provide{" "}
                <span className="font-extrabold">
                  high-confidence correlation
                </span>{" "}
                between structure and function-critical in oncology, neurology,
                cardiology, and complex systemic disease.
              </p>
            </div>
            <div className=" flex flex-col justify-center items-start xl:pt-0 pt-10">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  xl:pb-8 pb-4">
                PET-CT Is a Specialty-Not Just a Scanner
              </h2>
              <p className="pb-2 ">Accurate PET-CT imaging depends on:</p>
              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Appropriate radiopharmaceutical selection</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Optimized acquisition protocols</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Deep understanding of disease biology</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>
                    Careful correlation with prior imaging, treatment, and
                    clinical history
                  </span>
                </li>
              </ul>
              <p className=" py-2">
                At Citrus Diagnostic Center, PET-CT studies are{" "}
                <span className="font-extrabold">
                  radiologist-led from start to finish
                </span>
                , ensuring consistency, nuance, and clinical relevance.
              </p>
            </div>
          </div>
        </div>
        <div
          style={{
            background:
              "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
          }}
          className="rounded-xl  xl:py-24"
        >
          <div className="md:max-w-[90%] w-11/12   mx-auto  xl:py-28 xl:px-14 py-10 px-0 xl:bg-[#0f0f0f] rounded-xl">
            <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-8 gap-0 ">
              <div className="order-2 xl:order-1">
                <img
                  alt=" Oncology PET-CT"
                  className="rounded-3xl w-auto h-auto"
                  src={PETVideo}
                />
              </div>
              <div className="order-1 xl:order-2 py-5 xl:py-0  flex flex-col justify-center items-start xl:ps-10 ps-0">
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize ">
                    Oncology PET-CT
                  </h2>
                  <p className=" text-[#cccccc] font-normal">
                    See disease earlier. Treat more precisely.
                  </p>
                </div>
                <p className="pb-2">
                  PET-CT plays a central role in modern cancer care, including:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Initial detection</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Accurate staging</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Treatment response assessment</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Surveillance and recurrence detection</span>
                  </li>
                </ul>
                <p className=" py-2">
                  Our radiologists tailor each study based on:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Cancer type</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Clinical history</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Prior imaging and therapy</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-8 gap-0 lg:py-20 py-10">
              <div className=" flex flex-col justify-center items-start ">
                <div className="xl:pb-8 pb-4">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize ">
                    PSMA PET-CT (Prostate Cancer)
                  </h2>
                  <p className=" text-[#cccccc] font-normal">
                    Precision where it matters most.
                  </p>
                </div>
                <p className="pb-2">
                  PSMA PET-CT is a highly sensitive tool for:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Initial prostate cancer staging</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Biochemical recurrence</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Metastatic disease evaluation</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Treatment planning</span>
                  </li>
                </ul>
                <p className=" py-2">
                  This advanced molecular imaging technique allows detection of
                  disease at levels{" "}
                  <span className="font-extrabold">
                    not visible on conventional imaging
                  </span>
                  .
                </p>
                <div className="py-8">
                  <div className="xl:pb-8 pb-4">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                      Non-PSMA Prostate PET-CT
                    </h2>
                    <p className=" text-[#cccccc] font-normal">
                      When prostate cancer biology requires a different lens.
                    </p>
                  </div>
                  <p className="pb-2">
                    Not all prostate cancer behaves the same way.
                  </p>
                  <p className=" pb-2 ">
                    Non-PSMA PET-CT remains valuable in selected clinical
                    scenarios, particularly in biochemical recurrence.
                  </p>
                  <p className=" pb-2">
                    Offering both PSMA and non-PSMA PET reflects a{" "}
                    <span className="font-extrabold">
                      patient-specific, evidence-based approach
                    </span>
                    , rather than a one-size-fits-all model.
                  </p>
                </div>
              </div>
              <div className="">
                <img
                  alt=" Non-PSMA Prostate PET-CT"
                  className="rounded-3xl w-auto h-auto"
                  src={OncologyImage}
                />
              </div>
            </div>
            <div className="grid grid-col-1 xl:grid-cols-2 gap-8">
              <div className="order-2 xl:order-1">
                <img
                  src={NeuroendrocrinePET}
                  alt="Neuroendocrine Tumor (NET) PET-CT"
                  className="w-auto h-auto rounded-3xl"
                />
              </div>
              <div className="order-1 xl:order-2 xl:ps-10 ps-0">
                <div className="xl:pb-8 pb-4">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize ">
                    Neuroendocrine Tumor (NET) PET-CT
                  </h2>
                  <p className="text-[#cccccc] font-normal ">
                    Targeted imaging for complex tumors.
                  </p>
                </div>
                <p className=" pb-2">
                  Neuroendocrine tumors often require{" "}
                  <span className="font-extrabold">
                    specialized PET tracers
                  </span>{" "}
                  due to their unique biology.
                </p>
                <p className="pb-2">PET-CT for NETs is used to:</p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Localize primary tumors</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Detect metastatic disease</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Guide therapy selection</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Monitor treatment response</span>
                  </li>
                </ul>
                <p className="py-2">Accurate NET imaging requires:</p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Appropriate tracer selection</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Specialized acquisition protocols</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Experienced radiologist interpretation</span>
                  </li>
                </ul>
                <p className=" py-2">
                  Citrus Diagnostic Center provides PET-CT services designed to
                  meet these advanced requirements.
                </p>
              </div>
            </div>

            <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-8 gap-0 lg:pt-20">
              <div className=" flex justify-center items-start flex-col py-10 xl:py-0">
                <div className="xl:pb-8 pb-4">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize ">
                    Brain PET-CT
                  </h2>
                  <p className="text-[#cccccc] font-normal ">
                    When cognition and function matter.
                  </p>
                </div>
                <p className=" pb-2">
                  Brain PET-CT is used in the evaluation of:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Alzheimer’s disease</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Neurodegenerative disorders</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Cognitive decline of unclear etiology</span>
                  </li>
                </ul>
                <p className="py-2">
                  By assessing{" "}
                  <span className="font-extrabold">brain metabolism</span>,
                  PET-CT can:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Support earlier diagnosis</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Improve diagnostic confidence</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Help differentiate between causes of dementia</span>
                  </li>
                </ul>
              </div>
              <div className="">
                <img
                  src={ComparisonBrain}
                  alt="Comparison Brain PET"
                  className="w-auto h-auto rounded-3xl"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="md:max-w-[90%] w-11/12  xl:px-5 mx-auto xl:py-10 ">
          <div className="w-full flex justify-center items-center py-8 xl:px-0">
            <img
              src={NaturalImage}
              alt="PET AI imaging"
              className="h-auto w-auto rounded-xl  "
            />
          </div>
          <div className="relative bg-[#0f0f0f] rounded-xl xl:py-24 xl:mb-10">
            <img
              src={ScanImage}
              alt="Pet scan for Prostate Cancer
"
              className="
      absolute 
      top-1/2 
      left-1/2 
      -translate-x-1/2 
      -translate-y-1/2 
      pointer-events-none 
      z-0
      opacity-35
      
    "
            />
            <div>
              <div
                className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 xl:p-20 py-10 backdrop-blur-[2px]
    bg-[#ffffff1c] rounded-xl
      shadow-lg w-[]full xl:w-[90%] mx-auto"
              >
                <div className=" flex flex-col justify-center items-start px-5 xl:px-0">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize pb-8">
                    Who Interprets PET-CT-and Why It Matters
                  </h2>
                  <p className="pb-2">
                    PET-CT studies are interpreted by{" "}
                    <span className="font-extrabold">
                      board-certified radiologists with specialized training in
                      nuclear medicine and molecular imaging.
                    </span>
                  </p>
                  <p className="pb-2">This expertise is essential for:</p>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Accurate tracer interpretation</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Distinguishing treatment effects from disease</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Avoiding false positives or false reassurance</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Providing clinically actionable impressions</span>
                    </li>
                  </ul>
                  <p className="py-2">
                    At Citrus Diagnostic Center, PET-CT interpretation is{" "}
                    <span className="font-extrabold">
                      independent, physician-led, and clinically focused.
                    </span>
                  </p>
                </div>
                <div className="px-5 xl:px-0">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading capitalize pb-8">
                    Why Choose Citrus Diagnostic Center for{" "}
                    <span className="whitespace-nowrap">PET-CT</span>
                  </h2>

                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Radiologist owned and operated</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Deep legacy in PET &amp; nuclear imaging</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Board-certified radiologist interpretation</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Academic-level PET-CT protocols</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>
                        Oncology, neurologic, cardiac, prostate, and NET PET
                        expertise
                      </span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>
                        Integrated MRI + PET and multimodality correlation
                      </span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>
                        Independent, physician-led, patient-first philosophy
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:w-[80%] w-[90%] mx-auto  pb-10">
            <Faqs faqs={faqs} />
          </div>
          <div className="flex justify-center items-center py-10">
            <div
              style={{
                background: `
                      linear-gradient(90deg,
                    #3d0e26 0%,
                    #5a1f33 1%,
                    #8b5e3c 40%,
                    #8b5e3c 70%,
                    #5a1f33 95%,
                    #330a16 100%
                  )
                    `,
              }}
              className="flex justify-center items-center flex-col py-8 px-6 xl:px-8 rounded-xl xl:w-[668px] "
            >
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading texc  capitalize  ">
                Schedule with Confidence
              </h2>
              <p className=" pt-5  text-center">
                PET-CT imaging guided by experience, independence, and clinical
                insight.
              </p>
              <div className="pt-10 pb-2">
                <Link
                  data-aos="fade-up"
                  to="/contact-us"
                  aria-label="Schedule Now"
                  className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold text-[17px] hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
                >
                  Schedule Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
